import {Component, Input, OnInit} from '@angular/core';
import {CartElement} from '../../../models/cart-element';
import { PriceWeb } from '../../../../../projects/shared-lib/src/lib/models/price-web';
import { CartHeaderComponent } from '../cart-header/cart-header.component';
import { CartDetailComponent } from '../cart-detail/cart-detail.component';

@Component({
    selector: 'tw-ga',
    templateUrl: './ga.component.html',
    styleUrls: ['./ga.component.css'],
    imports: [CartHeaderComponent, CartDetailComponent]
})
export class GaComponent implements OnInit {
    @Input() cartElement: CartElement;
    @Input() price: PriceWeb;
    openPrices = false;

  constructor() {
  }

  ngOnInit() {
  }

}
